export default defineNuxtPlugin(async ({}) => {
	const msal = useMsalStore();
	await msal.initialize();

	return {};
});
